import React from "react";

function Contact() {
  return (
    <section
      className="contact-one jarallax"
      data-jarallax
      data-speed="0.2"
      data-imgposition="50% 0%"
      id="contactus"
    >
      <div
        className="contact-one__bg"
        style={{ backgroundImage: "url(/assets/images/suhani/bg1.webp)" }}
      ></div>

      <div className="container">
        <div className="row">
          {/* Left Section */}
          <div className="col-xl-7 col-lg-7">
            <div className="contact-one__left">
              <div className="section-title">
                <span className="section-title__tagline">Contact Us</span>
                <h2 className="section-title__title">
                  Suhani Builders
                </h2>
              </div>
              <p className="contact-one__left-text">
                For inquiries or to explore our services further, reach out to
                Suhani Builders today. Our team is dedicated to providing tailored
                solutions that meet your real estate needs with precision and expertise.
              </p>
            </div>
          </div>

          {/* Right Section - Contact Info */}
          <div className="col-xl-5 col-lg-5">
            <div
              className="contact-one__right wow slideInRight"
              data-wow-delay="100ms"
              data-wow-duration="2500ms"
            >
              <div className="contact-one__right-form">
                <div className="title-box">
                  <h4>Contact us</h4>
                </div>
                <div className="form-box">
                  <ul className="about-one__right-list list-unstyled">
                    <li className="about-one__right-list-item">
                      <div className="icon">
                        <span><i className="fas fa-map-marker-alt"></i></span>
                      </div>
                      <div className="text">
                        <p>6 Majestic Woods Dr. Monroe Township, NJ 08831</p>
                      </div>
                    </li>

                    <li className="about-one__right-list-item">
                      <div className="icon">
                        <span><i className="fas fa-phone-alt"></i></span>
                      </div>
                      <div className="text">
                        <p>+1 (732) 668 8291, +1 (732) 668 8296</p>
                      </div>
                    </li>

                    <li className="about-one__right-list-item">
                      <div className="icon">
                        <span><i className="fas fa-globe"></i></span>
                      </div>
                      <div className="text">
                        <p>www.suhanibuilders.com</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;